module.exports = __webpack_public_path__ + "media/Images/GettyImages-003-8851d687f6273208214943e4064fc21d.jpg";